/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */

/* eslint-enable no-console */


const sideTabs = document.querySelector( '.wp-block-iowa-aea-theme-side-tabs' );
// Add open to first tab
let tabs = sideTabs.querySelectorAll( '.impact-tab' );

if ( tabs.length > 0 ) {
  tabs[ 0 ].classList.add( 'open' );

  tabs.forEach(tab => tab.setAttribute('tabindex', 0))
}

// Click on tab Open it
tabs.forEach( tab => {
  tab.addEventListener( 'click', () => {
    tabs.forEach( t => t.classList.remove( 'open' ) );
    tab.classList.add( 'open' );
  } );

  tab.addEventListener( 'focus', () => {
    tabs.forEach( t => t.classList.remove( 'open' ) );
    tab.classList.add( 'open' );
  } );
} );
